module.exports = __webpack_public_path__ + "media/app/img/new-icon-2e182252ab2787e1e69388b4d0db8d6c.svg";